import axiosInstance from "./api_helper";

const deliveryService = {

    list: async ({ clientId, chantierId, commercialId, dateFrom, dateTo, query }) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (chantierId !== undefined && chantierId !== null) params.chantierId = chantierId;
        if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;

        const response = await axiosInstance.get('/api/ventes/bon-livraison', { params });

        return response.data;
    },

    add: async (deliveryData) => {
        return await axiosInstance.post('/api/ventes/bon-livraison-direct', deliveryData.data);
    },
    addBL: async (deliveryData) => {
        return await axiosInstance.post('/api/ventes/bon-livraison/creer', deliveryData.data);
    },
    update: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/api/ventes/bon-livraison/${id}`, JSON.stringify(data));
            return response;
        } catch (error) {
            throw error;
        }
    },
    generatePdf: async (deliveryDTO) => {
        const response = await axiosInstance.post(`/api/deliveryNotes/report`, deliveryDTO, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    delete: async (deliveryId) => {
        const response = await axiosInstance.delete(`/api/deliveryNotes/${deliveryId}`);
        return response.data;
    },
    filter: async (query) => {
        return axiosInstance.post(`/api/deliveryNotes/search`, JSON.stringify(query));
    },
    getLastSaved: async () => {
        return await axiosInstance.get(`/api/deliveryNotes/last-saved`);
    },
    
    findByReference: async (reference) => {
        const params = {};
        params.numero = reference;
        const response = await axiosInstance.get(`/api/ventes/bon-livraison/reference`, { params });
        return response.data;
    },
    uploadBLs: async (payload) => {
        return axiosInstance.post(`/api/ventes/bon-livraison/upload`, payload.formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
}

export default deliveryService;